import { isValidAnswer } from '~/helpers/answer_helper';
import { hasMatchedCondition } from '~/helpers/logic_helper';

export const selectInvalidQuestions = ({ questions, answers }) => {
  return questions.filter((question) => !isValidAnswer(question, answers[question.id]));
};

export const selectHasMetSurveyRequirements = ({ questions, answers }) => {
  // A survey with zero fetched questions (e.g. every question is attribute-gated
  // to a group this employee isn't in) is considered ready to submit, matching
  // fetchSurveySuccess's treatment of an empty question list — the two must
  // agree or the survey and submit pages redirect to each other forever.
  if (questions.length === 0) return true;

  return questions.reduce((surveyIsValid, question) => {
    const isNotVisible =
      question.displayConditions &&
      question.displayConditions.length > 0 &&
      !hasMatchedCondition(question.displayConditions, answers);
    if (isNotVisible) return surveyIsValid;
    return surveyIsValid && isValidAnswer(question, answers[question.id]);
  }, true);
};
